module.exports = __webpack_public_path__ + "static/img/stld.efd2728.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/stld.png
// module id = w4VV
// module chunks = 1